<template>
  <v-app>
    <home-app-bar />
    <home-drawer/>
    <home-view />
  </v-app>
</template>

<script>
import "@/assets/css/reset.css";
import "@/assets/css/common.css";
import "@/assets/css/front.css";

import { mapState } from 'vuex'

export default {
  name: 'Index',
  components: {
    HomeAppBar: () => import('@/pages/home/components/HomeAppBar'),
    HomeDrawer: () => import('@/pages/home/components/HomeDrawer'),
    HomeView: () => import('@/pages/home/components/HomeView'),
  },
  computed: {
    ...mapState['menuItemList']
  },
}
</script>

